import React from 'react';
import { Center, Divider, Text, Box, Tabs, Tab, TabPanel, TabPanels, TabList, Container, HStack, SimpleGrid } from '@chakra-ui/react';
import { BsCheckCircleFill } from 'react-icons/bs';
export default function Skills() {

    const frontendSkills = () => (
        <div>
            <SimpleGrid columns={3} spacing={4}>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>HTML/CSS</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Javascript</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>ReactJS</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Typescript</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>PWA</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>React Native</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>NextJS</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Redux</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Axios</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Bootstrap</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>MUI</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>ChakraUI</Text>
                </HStack>
            </SimpleGrid>
        </div>
    )

    const backendSkills = () => (
        <>
            <SimpleGrid columns={3} spacing={4}>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>PHP</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Flask</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>NodeJS</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Spring Boot</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>JPA</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Hibernate</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Maven</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>JWT</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>TFJS</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>SQL</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>MongoDB</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Postman</Text>
                </HStack>
            </SimpleGrid>
        </>
    )

    const cloudSkills = () => (
        <>
            <SimpleGrid columns={3} spacing={4}>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>GCP</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Docker</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Kubernetes</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>App Engine</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Firebase</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>OAuth</Text>
                </HStack>
            </SimpleGrid>
        </>
    )

    const moreSkills = () => (
        <>
            <SimpleGrid columns={2} spacing={4}>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Core Java (OOP)</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Python</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Machine Learning</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Peer Testing</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>scikit-learn</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>TensorFlow</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Git</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Linux</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Jira</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>PuTTY</Text>
                </HStack>
                <HStack>
                    <BsCheckCircleFill />
                    <Text>Figma</Text>
                </HStack>
            </SimpleGrid>
        </>
    )

    return (
        <div data-aos="fade-up">
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <Center height='50px' mt={3}>
                    <Divider orientation='vertical' className='vertical_divider' />
                </Center>
                <Text fontSize={"2xl"}
                    bgGradient='linear(to-l, #6dd5ed, #2193b0)'
                    bgClip='text'
                    fontWeight={"semibold"}
                >
                    Skills
                </Text>
            </Box>
            <Container maxW={"xl"}>
                <Tabs mt={4}>
                    <TabList>
                        <Tab>Frontend</Tab>
                        <Tab>Backend</Tab>
                        <Tab>Cloud</Tab>
                        <Tab>More...</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel>
                            {frontendSkills()}
                        </TabPanel>
                        <TabPanel>
                            {backendSkills()}
                        </TabPanel>
                        <TabPanel>
                            {cloudSkills()}
                        </TabPanel>
                        <TabPanel>
                            {moreSkills()}
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Container>
        </div>
    )
}
